import _ from 'lodash';
import queryString from 'query-string';
import 'core-js/features/url-search-params';
import {
  CRA_PREFIX,
  BRANDS,
  BRAND_DOMAINS,
  FEATURE_FLAGS,
  LOCALHOST_BOOKING_ENGINE_ENV,
  WIDGET_MODES,
  API_ACCESS_TOKEN
} from 'config';

export function validateRequiredArgs (appConfig, requiredArgs) {
  const missing = Object.keys(
    _.pickBy(
      _.pick(appConfig, requiredArgs),
      value => !value
    )
  );

  if (missing.length) {
    throw new Error(`[JP Widget] Missing required parameter${missing.length > 1 ? 's' : ''}: ${missing.join(', ')}`);
  }
}

export function validateBrand (brand) {
  if (!Object.keys(BRANDS).includes(brand)) {
    throw new Error(`[JP Widget] Invalid brand parameter: '${brand}'`);
  }
}

export function getFeatureFlags (scriptArgs) {
  const validScriptFlags = _.pick(scriptArgs, Object.keys(FEATURE_FLAGS));
  const validQueryStringFlags = _.pick(
    queryString.parse(window.location.search, { parseNumbers: true, parseBooleans: true }),
    Object.keys(FEATURE_FLAGS)
  );
  
  return {
    ...FEATURE_FLAGS,
    ...validScriptFlags,
    ...validQueryStringFlags
  };
}

export function getHostname (mode = WIDGET_MODES.SCRIPT) {
  try {
    // use only the hostname for privacy protection for iFrame mode hence the split
    return mode === WIDGET_MODES.IFRAME
      ? document.referrer.split("/")[2]
      : window.location.hostname;
  } catch (e) {}
}

export function getEnv (name, defaultValue) {
  return process.env[CRA_PREFIX + name] ?? defaultValue;
}

export function getEnvironment (brandDomain) {
  const { hostname } = window.location;

  if (hostname === 'localhost') {
    return 'local';
  } else if (hostname.includes('otrldev.uk')) {
    return 'test';
  } else if (hostname.includes('stage.otrl.io')) {
    return 'otrl-stage';
  } else if (hostname.includes('www.staging.' + brandDomain)) {
    return 'brochure-stage';
  } else if (hostname.includes('staging.' + brandDomain)) {
    return 'brochure-stage-new';
  } else if (hostname.includes(brandDomain)) {
    return 'prod';
  }

  return null;
}

function getApiEnv (apiUrl) {
  if (apiUrl.includes('stage.otrl.io')) {
    return 'stage';
  }
  
  if (!_.isEmpty(
    _.values(BRAND_DOMAINS)
    .filter(domain => apiUrl.includes(domain))
  )) {
    return 'prod';
  }

  return 'default';
}

export function getApiAccessToken (apiUrl) {
  const apiEnv = getApiEnv(apiUrl);
  return API_ACCESS_TOKEN[apiEnv];
}

export function getHost (brand, env) {
  const brandName = BRANDS[brand];
  const { origin, port } = window.location;

  switch (env) {
    case 'local':
      return origin.replace(`:${port}`, `:8080/${brandName}.${LOCALHOST_BOOKING_ENGINE_ENV}`);
    
    case 'test':
    case 'otrl-stage':
      return origin.replace(/widgets\./, `${brandName}.`);
    
    case 'brochure-stage':
      return origin.replace(/www\.staging\./, 'ticket.');

    case 'brochure-stage-new':
      return origin.replace(/staging\./, 'ticket.');

    case 'prod':
    default:
      return origin.replace(/www\./, 'ticket.');
  }
}

export function getRedirectCode (brand, redirectEnvironment) {
  const _brand = brand.toLowerCase();

  switch (redirectEnvironment) {
    case 'otrl-one-click-test-page':
      return redirectEnvironment;
    case 'staging':
      return `${_brand}-stage`;
    case 'production':
    default:
      return _brand;
  }
}
